import React, { useEffect, useState, useRef } from 'react';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import { connect } from 'react-redux';
import { buildUrlAndOpenWindow } from '../../../utilities/StringHelpers/StringHelpers';

import { initPage, goToPage, reportDWH } from './EquipmentMainSlice';
import EquipmentsPage from './pages/EquipmentsPage'; 
import ProductPage from './pages/ProductPage'

const EquipmentMain = (props) => {
  const [detailsProdact, setDetailsProdact] = useState(null); 
  let currentView = null;

  useExtendedEffect((runSideEffects) => {
    getData();
    if (runSideEffects()) {
    }
    props.reportDWH({ actionType: 'GeneralEquipment Page', status: 'Completed', messageText: 'GeneralEquipment Page Displayed' });
  }, []);

  async function getData() {
    await props.initPage({ epiData: props.iContent, context: props.context });
  };

  useClearStateResetFlag();

  const handleOnLinkClick = ()=>{
    window.history.back()
  };

  
  const moreDetails = (item)=>{
    setDetailsProdact(item);
    props.goToPage('productDescription');
 };

 const openInstallationGuide = (item) => {
  buildUrlAndOpenWindow(item?.installationGuide?.value);
 };

  switch (props.page) {
    case 'equipmentMain': 
      currentView = 
        <EquipmentsPage 
          context={props.context} 
          moreDetails={moreDetails} 
          openInstallationGuide={openInstallationGuide}  
        />; 
      break;
    case 'productDescription':
      currentView = 
        <ProductPage 
          detailsProdact={detailsProdact} 
          context={props?.context}  
          moreDetails={moreDetails} 
          openInstallationGuide={openInstallationGuide} 
        />; 
      break;
    default:
      currentView = <div>Page not found</div>;
  };

  return (
    <div className='equipment-page'>
        <div className='wrapper-equipments'>
        <div className="layout-container-equipments">
          {currentView}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.equipmentListPage.page,
  };
};

const mapDispatchToProps = {
  initPage,
  goToPage,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentMain);
